export default function Marquee({ items, className = "" }) {
  const content = [...items, ...items, ...items];
  return (
    <div
      className={`relative flex overflow-hidden bg-velvet-rose py-5 ${className}`}
      data-testid="marquee"
    >
      <div className="flex shrink-0 animate-marquee items-center whitespace-nowrap">
        {content.map((item, i) => (
          <span key={i} className="mx-6 flex items-center gap-6">
            <span className="font-heading text-2xl font-bold uppercase tracking-tight text-black md:text-3xl">
              {item}
            </span>
            <span className="text-2xl text-black">&#10038;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
